import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  team: PropTypes.shape({
    assignableUsersCount: PropTypes.number,
    deactivatedUsersCount: PropTypes.number,
    userIds: PropTypes.arrayOf(PropTypes.number)
  }).isRequired
};
const TeamSelectHelpMessage = ({
  team
}) => {
  /**
   * The concept of an "assignable" user is overloaded here, but here is some
   * historical context: Assignable users used to mean any user that had paid
   * seat access. See: https://knowledge.hubspot.com/account/manage-sales-hub-and-service-hub-paid-users
   *
   * The introduction of a "deactivated" user adds complexity since it no longer
   * makes sense to assign things to a deactivated user.
   *
   * Here, assignable users are users that have paid seat access and are not
   * deactivated.
   */
  const {
    assignableUsersCount: paidSeatUsersCount = 0,
    deactivatedUsersCount = 0,
    userIds
  } = team;
  if (!Array.isArray(userIds) || deactivatedUsersCount > paidSeatUsersCount || deactivatedUsersCount < 0) {
    return null;
  }
  const teamSize = userIds.length;
  const assignableUsersCount = paidSeatUsersCount - deactivatedUsersCount;

  // Full-lock cases
  // Team has no assignable users and should be disabled.
  if (teamSize === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.empty-team"
    });
  } else if (paidSeatUsersCount === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.full-lock"
    });
  } else if (assignableUsersCount === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.full-lock-all-deactivated"
    });
  }

  // Partial-lock cases
  // Team has assignable users, some of whom may be deactivated users.
  if (assignableUsersCount < teamSize) {
    return deactivatedUsersCount ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.partial-lock.some-deactivated-users",
      options: {
        assignableUsersCount,
        teamSize
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.users-and-teams.teams-select.help.partial-lock.no-deactivated-users",
      options: {
        assignableUsersCount,
        teamSize
      }
    });
  }

  // No-lock cases
  // Team only includes paid-seat users, none of whom are deactivated users.
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.users-and-teams.teams-select.help.members",
    options: {
      count: teamSize
    }
  });
};
TeamSelectHelpMessage.propTypes = propTypes;
export default TeamSelectHelpMessage;